<template>
  <section id="srp-preview">
    <SRPPreviewNavbar :selectedBrand="brand" @startOver="clearAll"/>
    <div id="preview" ref="preview">
      <div class="container-fluid">
        <v-layout>
        <v-flex xs12 >
          <component
            :is="componentTitle(srpComponent.title)" :component="srpComponent"
            class="webdash-component"
            :style="[brandData.colors, brandData.fonts]"
            :images="brandData.images"
          />
        </v-flex>
      </v-layout>
      </div>
      
      <div class="component-list">
        <v-layout row>
          <v-flex md6 xs12 offset-md3>
            <v-card class="mx-auto my-2 pa-4 preview-list">
              <v-list subheader>
                <v-subheader>SRP Features:</v-subheader>
                <template v-for="component in chosenComponents">
                  <v-list-tile :key="component.id">
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-text="component.title"
                      ></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </section>
</template>

<script>
import SRPPreviewNavbar from '@/components/SRPPreviewNavbar.vue';
import webdashComponents from "../webdash_components";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand,
    }
  },
  mounted () {
    window.scrollTo(0, 0);
    document.getElementById('app').scrollIntoView();

    let headings = $('.webdash-component').find(":header")
    let links = $('.webdash-component').find("a, button")
    if (this.brand === 'chevrolet' || this.brand === 'hyundai' || this.brand === 'mazda') {
      headings.css({ textTransform:'uppercase'});
    }
    if (this.brand === 'mazda') {
      headings.css({ textTransform:'uppercase', letterSpacing:'1px'});
      links.css({ textTransform:'uppercase', fontSize:'13px', letterSpacing:'2px', borderRadius:'3px'});
    }
  },
  computed: {
    ...mapState(['chosenBrand']),
    ...mapState({
      chosenComponents: state => state.chosenComponents
    }),
    ...mapGetters(["imagePreview", "brandData"]),
    srpComponent() {
      return this.chosenComponents.find(c => c.type === 'srp') 
    }
  },
  methods: {
    componentTitle(title) {
      return title.toLowerCase().replaceAll(" ", "-");
    },
    shoot() {
      this.$html2canvas(document.querySelector("#preview")).then(function(
        canvas
      ) {
        canvas.toBlob(function(blob) {
          saveAs(blob, "srp.png");
        });
      });
    },
    clearAll() {
      this.currentFlow = ''
      this.$store.state.chosenComponents = [];
      this.$store.commit("chooseBrand", "None");
      this.selectedBrand = "None";
    }
  },
  components: {
    SRPPreviewNavbar,
    ...webdashComponents
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
#preview {
  width: 100%;
}
.component-list {
  background: #eee;
  padding-top: 30px;
  padding-bottom: 30px;
}
.v-list__tile:before {
  content: "";
  height: 2px;
  width: 8px;
  background: #777;
  margin-right: 10px;
}
.v-btn {
  z-index: 15;
}
.camera-btn {
  background-color: #006AFF !important;
}
</style>

<style>
#srp-preview {
  position:relative;
}
#preview .preview-list .v-list__tile:before {
  content: "";
  height: 2px;
  width: 8px;
  margin-right: 10px;
}
#preview .preview-list {
  box-shadow: 1px 1px 10px 5px rgba(0,0,0,.1);
  border-radius: 4px;
}
</style>
